// eslint-disable-next-line import/no-cycle
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'moment/locale/eu';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ca';
import 'moment/locale/gl';
import { isMobile } from 'react-device-detect';
import { ReactComponent as CloseSvg } from '../assets/svg/close.svg';
import rotatedLogo from '../assets/images/logo-rotado.png';
import SessionService from '../services/SessionService';
import { useAppStore } from '../store/AppContext';

const appEroskiEsUrl = 'https://www.eroski.es/apps-eroski/';
const appEroskiEuUrl = 'https://www.eroski.es/eu/eroski-appak/';
const appEroskiEsMovilUrl = 'https://eroski.onelink.me/pF7u/e5d37d';
const appEroskiEuMovilUrl = 'https://eroski.onelink.me/pF7u/y0ipevak';

interface Props {
  page: string;
}

const DownloadAppPopup: FC<Props> = (props) => {
  const { page } = props;
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [textMensaje, setMensaje] = useState<string>('');
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const idioma = dataApp.lang;

  function escogeURL(): void {
    if (isMobile) {
      switch (idioma) {
        case 'es':
          window.open(appEroskiEsMovilUrl, '_blank');
          break;
        case 'eu':
          window.open(appEroskiEuMovilUrl, '_blank');
          break;
        default:
          window.open(appEroskiEsUrl, '_blank');
      }
    } else {
      switch (idioma) {
        case 'es':
          window.open(appEroskiEsUrl, '_blank');
          break;
        case 'eu':
          window.open(appEroskiEuUrl, '_blank');
          break;
        default:
          window.open(appEroskiEsUrl, '_blank');
      }
    }
  }

  function escogeMensaje() {
    let mesajePopup;
    switch (page) {
      case 'vales':
        mesajePopup = 'popup-descarga-app.message-vales';
        break;
      case 'saldo':
        mesajePopup = 'popup-descarga-app.message-saldo';
        break;
      case 'ahorros':
        mesajePopup = 'popup-descarga-app.message-ahorro';
        break;
      default:
        mesajePopup = 'popup-descarga-app.message-ahorro';
    }
    return mesajePopup;
  }

  useEffect(() => {
    SessionService.checkAppSession()
      .then((response) => {
        if (
          response.data.error === false &&
          response.data.pojo.appDescargada === false
        ) {
          setMensaje(escogeMensaje());
          setShowPopup(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (showPopup) {
    return (
      <div className="popup-descargar-app">
        <div className="popup-descargar-app__logo-wrapper">
          <img src={rotatedLogo} alt="Logo de eroski" />
        </div>
        <div>
          <p className="popup-descargar-app__title">
            {t('popup-descarga-app.title')}
          </p>
          <p>{t(textMensaje)}</p>
          <button
            title={t('popup-descarga-app.title')}
            className="popup-descargar-app__button"
            type="button"
            onClick={() => escogeURL()}
          >
            {t('popup-descarga-app.button')}
          </button>
        </div>
        <CloseSvg
          title="Cerrar popup de descarga"
          onClick={() => setShowPopup(false)}
          width="20px"
          height="20px"
          fill="#cd0810"
          stroke="#cd0810"
          cursor="pointer"
        />
      </div>
    );
  }
  return null;
};

export default DownloadAppPopup;
